import { CalculationEngine } from '../calculations/calculationModel';

export function createCalculationWorker() {
  // CRA/Webpack emits a separate worker bundle; raw records stay off React's thread.
  const worker = new Worker(new URL('./energyCalculation.worker.js', import.meta.url));
  let nextId = 0;
  const requests = new Map();
  worker.onmessage = ({ data }) => {
    const pending = requests.get(data.id);
    if (!pending) return;
    requests.delete(data.id);
    if (data.error) pending.reject(new Error(data.error)); else pending.resolve(data.result);
  };
  worker.onerror = () => {
    requests.forEach(pending => pending.reject(new Error('Energy calculations could not be completed.')));
    requests.clear();
  };
  return {
    call(method, ...args) {
      const id = ++nextId;
      return new Promise((resolve, reject) => { requests.set(id, { resolve, reject }); worker.postMessage({ id, method, args }); });
    },
    close() {
      worker.terminate();
      requests.forEach(pending => pending.reject(new Error('Energy scope changed.'))); requests.clear();
    },
  };
}

// Test and non-worker environments use the identical domain engine.
export function createInlineCalculator() {
  const engine = new CalculationEngine();
  return { call: async (method, ...args) => engine[method](...args), close() {} };
}
